import { PAD_ITEM_TYPE } from 'app/config/pad_item.js';
export default class BuildPadItem {
  constructor(padItem) {
    this._padItem = padItem;
    this._padItem.name = padItem.furnitureName ? padItem.furnitureName : padItem.name;
    this._padItem.type = PAD_ITEM_TYPE.FURNITURE;
  }

  addPadItemCode = function (code) {
    this._padItem.code = code;

    return this;
  };

  addPadItemType = function (type) {
    this._padItem.type = type;

    return this;
  };

  addStatus = function (status) {
    this._padItem.status = status;

    return this;
  };

  setUpdateStatus = function () {
    this._padItem.itHasBeenUpdated = true;

    return this;
  };

  getPadItem = function () {
    return this._padItem;
  };

  cleanPadItem = function () {
    delete this._padItem.id;
    delete this._padItem.code;
    //delete this._padItem.PadItemType;
    delete this._padItem.PadItemAlterId;

    delete this._padItem.pad;
    delete this._padItem.padId;

    delete this._padItem.created;
    delete this._padItem.updated;

    this._padItem.PadItemAlterId = null;

    return this;
  };
}
